import {
  Button,
  DialogActions,
  DialogContent,
  Typography,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import useDialogVisibility from '../../../utils/dialog-hide';

type Props = {
  close: any;
  handleClockIn: any;
};

const ClockInOutModal = (props: Props) => {
  const { close, handleClockIn } = props;
  const checkoutResponse = useSelector((state: any) => state.checkoutReducer);
  const [checked, setChecked] = useState(false);

  const { setDoNotshowAgain: setClockInDoNotShowAgain } =
    useDialogVisibility('clock_in_do_not_show');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const dontClockIn = () => {
    setClockInDoNotShowAgain(checked ? true : false);
    close();
  };

  useEffect(() => {
    if (checkoutResponse?.clockAction === 'CLOCK_IN_SUCCESS') {
      setClockInDoNotShowAgain(checked ? true : false);
      close();
    }
  }, [checkoutResponse, close]);

  return (
    <Box p={3}>
      <>
        <DialogContent>
          <Box sx={{ display: 'flex' }}>
            <Box>
              <Typography variant="h5">Would you like to Clock-In?</Typography>
              <Typography
                sx={{ color: '#6C737F', fontWeight: '400', width: '100%' }}
                variant="body2"
                mt={0.2}
                mr={5}
              >
                Clock-in to accurately track your working hours.
              </Typography>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="outlined"
            sx={{
              border: '1px solid #38425080',
              color: '#384250',
              '&:hover': {
                border: '1px solid #38425080',
              },
            }}
            onClick={dontClockIn}
          >
            No, Don’t Clock-in.
          </Button>
          <Button
            autoFocus
            variant="contained"
            onClick={handleClockIn}
            disabled={checkoutResponse?.loading}
          >
            Yes, Start the Clock.
          </Button>
        </DialogActions>
        <FormControlLabel
          style={{ left: 25, position: 'relative' }}
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              inputProps={{ 'aria-label': 'controlled' }}
            />
          }
          label={'Do not show this message again'}
        />
      </>
    </Box>
  );
};

export default ClockInOutModal;
